module.exports = __webpack_public_path__ + "static/media/country_er.bbe95b8c.webp";